<template>
  <div class="configurator_app">
    <canvas class="renderCanvas" ref="renderCanvas"></canvas>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {masterBus} from '@/main.js';

export default {
  name: 'ConfiguratorCanvas',
  data(){
    return {
      app:null,
      //loader:null,
      zoomContainer:null,
      isoScalingContainer:null,
      basePlane:null,
      wheelsPlane:null,
      arrangementsPlane:null,
      arrangementsPlanes:[],
      configuratorIsOn:false,
      animationRunning:false,
      objectsScene:[],
      currentArrangment:null,
      circle:null,
      zones:[],
      zoneAnimationTL:null,
      scaleFactorFurnitures:.64,
      zonesPosition:[
        [-25,-47], //0
        [3,-246],//1
        [-3,-438],//2
        [-179,-27],//3
        [-188,-250], //4
        [-192,-442],//5
        [-4,-630]//6
      ],
      zoneBigPositionSmallPod:[0,-440],
      darkMode:false,
      pixelateMode:false
      }
  },
  watch:{
    podSize : function(val){
      this.changeSkateBoardSize(val);
    }
  },
  computed: {
    ...mapGetters(['loader','configuratorReady','podSize'])
  },
  beforeDestroy(){
    masterBus.$off('initConfigurator', this.initPIXI);
    masterBus.$off('placeArrangement', this.placeArrangement);
    masterBus.$off('displayDropZone', this.displayDropZone);
    masterBus.$off('hideDropZone', this.hideDropZone);
    masterBus.$off('showAvailableDropZones', this.showAvailableDropZones);
    masterBus.$off('hideAvailableDropZones', this.hideAvailableDropZones);
    masterBus.$off('resetSkateboard', this.resetSkateboard);
  },
  mounted(){
      masterBus.$on('initConfigurator', this.initPIXI);
      masterBus.$on('placeArrangement', this.placeArrangement);
      masterBus.$on('displayDropZone', this.displayDropZone);
      masterBus.$on('hideDropZone', this.hideDropZone);
      masterBus.$on('showAvailableDropZones', this.showAvailableDropZones);
      masterBus.$on('hideAvailableDropZones', this.hideAvailableDropZones);
      masterBus.$on('deleteFurniture', this.deleteFurniture);
      masterBus.$on('resetSkateboard', this.resetSkateboard);
  },
  methods:{
    changeSkateBoardSize(size){
      masterBus.$emit('hideControlsFurniture');
      if(size == "S"){
        new TweenMax.to(this.zoomContainer,.4,{ease:  Power2.easeOut,pixi:{x:this.app.screen.width / 2+100}});
          this.basePlane.children[0].texture = PIXI.utils.TextureCache['plateforme-small.png'];
          this.wheelsPlane.children[0].texture = PIXI.utils.TextureCache['plateforme-small_wheels.png'];
        this.zones[0].position.set(this.zoneBigPositionSmallPod[0],this.zoneBigPositionSmallPod[1]);
        this.zones[1].removeChild(this.zones[1].children[2]);
        this.zones[4].removeChild(this.zones[4].children[2]);
        if(this.zones[6].children[2]){
          if(this.zones[6].children[2].category == "F"){
            this.zones[6].removeChild(this.zones[6].children[2]);
          }
        }
      }
      else {
        new TweenMax.to(this.zoomContainer,.4,{ease:  Power2.easeOut,pixi:{x:this.app.screen.width / 2}});
          this.basePlane.children[0].texture = PIXI.utils.TextureCache['plateforme.png'];
          this.wheelsPlane.children[0].texture = PIXI.utils.TextureCache['plateforme_wheels.png'];
        this.zones[0].position.set(this.zonesPosition[6][0],this.zonesPosition[6][1])
      }
    },
    initPIXI(){
      const renderCanvas = this.$refs.renderCanvas;
      this.app = new PIXI.Application({
          view: renderCanvas,
          backgroundColor: 0xf4f4f4,
          width:$('.renderCanvas').width(), //// OPTIMIZE: Canvas size is too big when displayed on retina screens
          height:$('.renderCanvas').height(),
          //antialias: true,    // default: false
          transparent: false, // default: false
          resolution: 1,       // default:
          resolution: window.devicePixelRatio,
          autoResize:true
        });
      this.startIsoContainer();
    },
    startIsoContainer(){
      this.zoomContainer = new PIXI.Container();
      this.zoomContainer.x = this.app.screen.width / 2;
      this.zoomContainer.y =  this.app.screen.height*.6;
      this.zoomContainer.pivot.x = this.zoomContainer.width / 2;
      this.zoomContainer.pivot.y = this.zoomContainer.height / 2;
      if($(window).width()>1600) this.zoomContainer.scale.x = this.zoomContainer.scale.y = 1.2;
      else if($(window).width() <= 600) this.zoomContainer.scale.x = this.zoomContainer.scale.y = .5;
      else if($(window).width() <= 1100){
        this.zoomContainer.scale.x = this.zoomContainer.scale.y = .8;
      }

      this.isoScalingContainer = new PIXI.Container();
      this.isoScalingContainer.scale.y = 0.55; // isometry can be achieved by setting scaleY 0.5 or tan(30 degrees)

      this.arrangementsPlane = new PIXI.Graphics();
      this.arrangementsPlane.rotation = Math.PI/4;

      this.basePlane = new PIXI.Graphics();
      this.basePlane.rotation = Math.PI/4;

      this.wheelsPlane = new PIXI.Graphics();
      this.wheelsPlane.rotation = Math.PI/4;

      var skateboard =new PIXI.projection.Sprite2d(PIXI.utils.TextureCache["plateforme.png"]); //require("../assets/cube.png")
      skateboard.pivot.x = 30 * 14;
      skateboard.pivot.y = skateboard.height;
      skateboard.position.set(0,0);
      skateboard.proj.affine = PIXI.projection.AFFINE.AXIS_X;
      skateboard.scale.set(.8);
      skateboard.rotation = -Math.PI/4;

      var wheels =new PIXI.projection.Sprite2d(PIXI.utils.TextureCache["plateforme_wheels.png"]); //require("../assets/cube.png")
      wheels.pivot.x = 30 * 14;
      wheels.pivot.y = wheels.height;
      wheels.position.set(0,0);
      wheels.proj.affine = PIXI.projection.AFFINE.AXIS_X;
      wheels.scale.set(.8);
      wheels.rotation = -Math.PI/4;

      this.initZones();
      this.basePlane.addChild(skateboard);
      this.wheelsPlane.addChild(wheels);

      this.arrangementsPlane.position.set(50,-226);
      this.isoScalingContainer.addChild(this.basePlane,this.arrangementsPlane,this.wheelsPlane);
      this.isoScalingContainer.position.set(-skateboard.width/4, skateboard.height/2);
      this.zoomContainer.addChild(this.isoScalingContainer);
      this.app.stage.addChild(this.zoomContainer);
      window.addEventListener('resize', this.resizeCanvas);
      this.resizeCanvas()
      this.$store.dispatch('setConfiguratorReady',true);
      masterBus.$emit("startApp");
    },
    initZones(){
      for(let i=6; i >= 0; i--){
        let zone = new PIXI.Container();
        let zoneSprite;
        if(i == 0) {
          zoneSprite = new PIXI.projection.Sprite2d(PIXI.utils.TextureCache["zone-front-right.png"]);
          zoneSprite.pivot.x = zoneSprite.width/2-25;
          zoneSprite.pivot.y = zoneSprite.height+3;
        }
        else if(i == 3) {
          zoneSprite = new PIXI.projection.Sprite2d(PIXI.utils.TextureCache["zone-front-left.png"]);
          zoneSprite.pivot.x = zoneSprite.width/2-39;
          zoneSprite.pivot.y = zoneSprite.height;
        }
        else if(i == 6){
          zoneSprite = new PIXI.projection.Sprite2d(PIXI.utils.TextureCache["zone-big.png"]);
          zoneSprite.pivot.x = zoneSprite.width/2+98;
          zoneSprite.pivot.y = zoneSprite.height;
        }
        else{
          zoneSprite = new PIXI.projection.Sprite2d(PIXI.utils.TextureCache["zone-middle.png"]);
          zoneSprite.pivot.x = zoneSprite.width/2;
          zoneSprite.pivot.y = zoneSprite.height;
        }
        zoneSprite.scale.set(.79);
        zoneSprite.position.set(0,0);
        zoneSprite.alpha=0;
        zoneSprite.rotation = -Math.PI/4;
        zoneSprite.proj.affine = PIXI.projection.AFFINE.AXIS_X;
        let circle = new PIXI.Graphics();
        circle.beginFill(0xff5e00);
        // circle.drawCircle(0,0,4);
        zone.addChild(circle,zoneSprite);
        zone.position.set(this.zonesPosition[i][0],this.zonesPosition[i][1]);
        this.zones.push(zone);
        this.arrangementsPlane.addChild(this.zones[6-i]);
        let params={
          "index":i,
          "worldTransform":zone.transform.worldTransform,
          "pivotX": zoneSprite.pivot.x - 50,
          "pivotY": zoneSprite.pivot.y + zoneSprite.height/2
        }
        setTimeout(()=>{
          masterBus.$emit('setDropZonePosition',params);
        },200)
      }
    },
    resizeDropZone(){
      for(let i=6; i >= 0; i--){
        let zone = this.zones[6-i];
        let params={
          "index":i,
          "worldTransform":zone.transform.worldTransform,
          "pivotX": zone.children[1].pivot.x - 50,
          "pivotY": zone.children[1].pivot.y + zone.children[1].height/2
        }
        setTimeout(()=>{
          masterBus.$emit('setDropZonePosition',params);
        },200)
      }
    },
    displayControlsFurniture(furniture,x,y){
      let params = {
        'furniture': furniture,
        'x':furniture.target.worldTransform.tx + furniture.target.width/2 - 20,
        'y':furniture.target.worldTransform.ty +  furniture.target.height - 80
      }
      masterBus.$emit("displayControlsFurniture",params);
    },
    deleteFurniture(params){
      let newParams = params;
      var timelineFurniture = new TimelineMax({onComplete:  this.removeFurnitureAsset,onCompleteParams:[newParams]});
      timelineFurniture.to(this.zones[6-params].children[2],.1, {ease:  Power2.easeOut,pixi:{scale: this.scaleFactorFurnitures - .2,alpha:0}});
    },
    removeFurnitureAsset(params){
      this.zones[6-params].removeChild(this.zones[6-params].children[2]);
    },
    resetSkateboard(){
      for(let i=6; i >= 0; i--){
        if(this.zones[i].children[2]){
          this.zones[i].removeChild(this.zones[i].children[2]);
        }
      }
    },
    placeArrangement(params){
      this.hideDropZone(params.zone);
      let zoneIndex=6-params.zone;
      if(params.category == "F"){
        this.resetSkateboard();
        zoneIndex = 6;
      }
      else{
        this.zones[zoneIndex].removeChild(this.zones[zoneIndex].children[2]);
      }
      let elem = new PIXI.projection.Sprite2d(PIXI.utils.TextureCache[params.arrangement]);
      this.zones[zoneIndex].addChild(elem);
      this.zones[zoneIndex].children[2].zone = params.zone;
      this.zones[zoneIndex].children[2].category = params.category;
      if(params.category =="F"){
        this.zones[zoneIndex].children[2].pivot.x = this.zones[zoneIndex].children[2].width*0.2845;
        this.zones[zoneIndex].children[2].pivot.y = this.zones[zoneIndex].children[2].height+3;
      }
      else if(params.category =="FR"){
        this.zones[zoneIndex].children[2].pivot.x = this.zones[zoneIndex].children[2].width*.4370;
        this.zones[zoneIndex].children[2].pivot.y = this.zones[zoneIndex].children[2].height;
      }
      else if(params.category =="FL"){
        this.zones[zoneIndex].children[2].pivot.x = this.zones[zoneIndex].children[2].width*.37;
        this.zones[zoneIndex].children[2].pivot.y = this.zones[zoneIndex].children[2].height;
      }
      else if(params.category =="BL"){
        this.zones[zoneIndex].children[2].pivot.x = this.zones[zoneIndex].children[2].width*0.703;
        this.zones[zoneIndex].children[2].pivot.y = this.zones[zoneIndex].children[2].height;
      }
      else{
        this.zones[zoneIndex].children[2].pivot.x = this.zones[zoneIndex].children[2].width/2;
        this.zones[zoneIndex].children[2].pivot.y = this.zones[zoneIndex].children[2].height;
      }
      this.zones[zoneIndex].children[2].rotation = -Math.PI/4;
      this.zones[zoneIndex].children[2].proj.affine = PIXI.projection.AFFINE.AXIS_X;
      this.zones[zoneIndex].children[2].position.set(0,0);
      this.zones[zoneIndex].children[2].scale.set(this.scaleFactorFurnitures -.2);
      this.zones[zoneIndex].children[2].alpha = 0;
      this.zones[zoneIndex].children[2].interactive = true;
      this.zones[zoneIndex].children[2].on('mousedown', this.displayControlsFurniture)
                                           .on('touchstart', this.displayControlsFurniture)
      TweenMax.to(this.zones[zoneIndex].children[2], .3, {ease:  Elastic.easeOut.config(1, 0.3),pixi:{scale:this.scaleFactorFurnitures,alpha:1}});
    },
    displayDropZone(zones){
      for(let i in zones){
        TweenMax.to(this.zones[6-zones[i]].children[1], .8, {ease:  Power2.easeOut,pixi:{alpha:.8}});
      }
    },
    showAvailableDropZones(zones){
      for(let i in zones){
        var Timeline = new TimelineMax();
        if((zones[i] !== 2) && (zones[i] !== 5)){
          Timeline.to(this.zones[6-zones[i]].children[1], 1, {ease:  Power2.easeOut,pixi:{alpha:.2}});
        }
        else{
          if(this.podSize == "S"){

          }
          else{
            Timeline.to(this.zones[6-zones[i]].children[1], 1, {ease:  Power2.easeOut,pixi:{alpha:.2}});
          }
        }
      }
    },
    hideAvailableDropZones(zones){
      for(let i in zones){
        for(let i in zones){
          var Timeline = new TimelineMax();
          Timeline.to(this.zones[6-zones[i]].children[1], 1, {ease:  Power2.easeOut,pixi:{alpha:0}});
        }
      }
    },
    hideDropZone(zones){
      for(let i in zones){
        TweenMax.to(this.zones[6-zones[i]].children[1], .8, {ease:  Power2.easeOut,pixi:{alpha:0}});
      }
    },
    moveObject(){
      if(this.objectsScene[1].x > -225){
        TweenMax.to(this.objectsScene[1], 2, {ease: Expo.easeOut,pixi:{x:this.objectsScene[1].x-45}});
      }
      else{
        TweenMax.to(this.objectsScene[1], 2, {ease: Expo.easeOut,pixi:{y:this.objectsScene[1].y-45}});
      }
    },
    resizeCanvas(){
    	const parent = this.app.view.parentNode;
    	this.app.renderer.resize($(window).width(), $(window).height());
      this.zoomContainer.x = parent.clientWidth / 2;
      this.zoomContainer.y =  $(window).height()*.6;
      if(parent.clientWidth <= 600){
        this.zoomContainer.scale.x = this.zoomContainer.scale.y = .5;
        this.zoomContainer.y =  parent.clientHeight*.5;
      }
      else if(parent.clientWidth <= 1100){
        this.zoomContainer.scale.x = this.zoomContainer.scale.y = .8;
        this.zoomContainer.y =  parent.clientHeight*.6;
      }
      else if(parent.clientWidth > 1600){
        this.zoomContainer.scale.x = this.zoomContainer.scale.y = 1.2;
        this.zoomContainer.y =  $(window).height()*.6;
      }
      else{
        this.zoomContainer.scale.x = this.zoomContainer.scale.y = 1;
      }
      this.resizeDropZone();
    }
  }
}
</script>

<style lang="scss">

.configurator_app{
    width: 100vw;
    height: 100vh;
    position: relative;
    opacity: 0;
    transform: translateY(400px);
    .renderCanvas{
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: white;
    }
}
</style>
